import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './permission';
import './icons'; // icon
import '@/styles/reset.css';
import moment from 'moment';
import '@/styles/common.less';
import './styles/element-#1C1C1C/index.css';
import ElementUI from 'element-ui';
import '@/assets/icon/iconfont.css';
import 'croppie/croppie.css'; // import the croppie css manually
import api from '@/api';
import VueCroppie from 'vue-croppie';
Vue.use(VueCroppie);

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(ElementUI);
Vue.prototype.$Api = api;
Vue.prototype.$moment = moment;
Vue.prototype.$Map = window.TMap;
// Vue.prototype.$Location = new window.qq.maps.Geolocation('OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77', '腾讯地图模板')
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
